/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useRef } from "react";
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Grid, GridCellProps, GridColumn } from "@progress/kendo-react-grid";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui";
import type { NumericTextBoxChangeEvent } from "@progress/kendo-react-inputs";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { showToast } from "utils/helper";

function PartialDeliveryInfo({
  containers,
  onUpdatedData,
}: {
  containers: any[];
  onUpdatedData: (data: any) => void;
}) {
  function StatusDropdownCell(props: any) {
    const { dataIndex, dataItem } = props;
    return (
      <td>
        <Select
          onValueChange={(val: string) => {
            const updatedData = containers.map((item: any) => {
              if (item.sealNo === dataItem.sealNo) {
                return {
                  ...item,
                  status: val,
                  returnedCount: val === "Returned" ? item.count : 0,
                };
              }
              return item;
            });
            onUpdatedData(updatedData);
          }}
          value={containers[dataIndex]?.status}
        >
          <SelectTrigger className="h-8">
            <SelectValue placeholder="Select Status" />
          </SelectTrigger>
          <SelectContent>
            {["Delivered", "Returned"].map((item: string) => (
              <SelectItem key={item} value={item}>
                {item}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </td>
    );
  }

  function CoinsReceived(props: GridCellProps) {
    const { dataItem, field } = props;

    const inputRef = useRef<number>(0);
    const onChange = (e: NumericTextBoxChangeEvent) => {
      let value = e.target.value as unknown as number;
      if (!e.target.value) value = 0;
      inputRef.current = value;
    };

    const onBlur = () => {
      if (field) updateKeyInDenominationEntry(dataItem, inputRef?.current);
    };

    const updateKeyInDenominationEntry = (rowData: any, value: number) => {
      onUpdatedData(
        containers.map((row: any) => {
          if (
            row.containerType === rowData.containerType &&
            row.containerId === rowData.containerId &&
            row.details === rowData.details &&
            rowData.count >= value
          ) {
            return {
              ...row,
              returnedCount: Number(value || 0),
              status: value && row.count <= value ? "Returned" : "Delivered",
            };
          }

          if (value > rowData.count) {
            showToast("error", "Returned count cannot be more than Count");
          }
          return row;
        }),
      );
    };

    return (
      <td>
        <NumericTextBox
          step={0}
          spinners={false}
          className="w-full h-8"
          value={dataItem?.returnedCount || 0}
          onChange={onChange}
          onBlur={onBlur}
          defaultValue={0}
          min={0}
          required
        />
      </td>
    );
  }

  return (
    <>
      <h4 className="font-semibold mt-3">Packages</h4>
      <Grid
        data={containers?.filter(
          (item: any) => item.consignmentType !== "Coins",
        )}
        className="my-2"
        size="small"
      >
        <GridColumn field="containerType" title="Bag Type" />
        <GridColumn field="containerId" title="Bag Id" />
        <GridColumn field="currency" title="Currency" />
        <GridColumn field="declaredValue" format="{0:N2}" title="Value" />
        <GridColumn field="sealNo" title="SealNo" />
        <GridColumn field="status" title="Status" cell={StatusDropdownCell} />
      </Grid>
      <h4 className="font-semibold">Coins</h4>
      <Grid
        data={containers?.filter(
          (item: any) => item.consignmentType === "Coins",
        )}
        className="my-2"
        size="small"
      >
        <GridColumn field="containerType" title="Bag Type" />
        <GridColumn field="containerId" title="Bag Id" />
        <GridColumn field="details" title="Denomination" />
        <GridColumn field="count" title="Count" />
        <GridColumn
          field="returnedCount"
          title="Returned"
          cell={CoinsReceived}
        />
      </Grid>
    </>
  );
}

export default React.memo(PartialDeliveryInfo);
